export const DUBAI_AREAS = [
  "Downtown Dubai",
  "Dubai Marina",
  "Palm Jumeirah",
  "Jumeirah Beach Residence",
  "Business Bay",
  "Dubai Hills Estate",
  "DIFC",
  "Jumeirah Village Circle",
  "Al Barsha",
  "Deira",
  "Mirdif",
  "Dubai Creek Harbour",
  "Dubai Land",
  "Umm Suqeim",
  "Other"
];

export const AREA_CODE_MAP: Record<string, string> = {
  "Downtown Dubai": "DO",
  "Dubai Marina": "MR",
  "Jumeirah Village Circle": "JV",
  "Palm Jumeirah": "PJ",
  "Jumeirah Beach Residence": "JB",
  "Business Bay": "BB",
  "Dubai Hills Estate": "DH",
  "Al Barsha": "BA",
  "Deira": "DE",
  "Mirdif": "MI",
  "Dubai Creek Harbour": "DC",
  "Dubai Land": "DL",
  "DIFC": "DF",
  "Umm Suqeim": "US",
  "Other": "OT"
};

export const AREA_NAME_MAP: Record<string, string> = Object.fromEntries(
  Object.entries(AREA_CODE_MAP).map(([name, code]) => [code, name])
); 